import Accordion from 'react-bootstrap/Accordion'
import Alert from 'react-bootstrap/Alert'

import { useDeployedContractStore } from "../../zustand/deployedContractStore"
import { DeployedContract } from './DeployedContract'
import { DeployedContractsProps } from '../../types/props'

const DeployedContracts = ({ client, gasLimit, value }: DeployedContractsProps) => {
    const { deployedContracts } = useDeployedContractStore()

    return (
        <>
            <h6 className="deployed-contracts-header">Deployed Contracts</h6>

            {deployedContracts.length === 0 && (
                <Alert variant='info' className='deployed-contracts-alert'>
                    Currently you have no deployed contracts to interact with.
                </Alert>
            )}
            
            <Accordion>
                {deployedContracts.map((contract, contractIdx) => (
                    <DeployedContract
                        key={`${contract.address}-${contractIdx}`}
                        client={client}
                        deployedContractsLength={deployedContracts.length}
                        contractIdx={contractIdx}
                        contractName={contract.name}
                        contractAbi={contract.abi}
                        contractAddress={contract.address}
                        gasLimit={gasLimit}
                        value={value}
                    />
                ))}
            </Accordion>
        </>
    )
}

export default DeployedContracts